module.exports = __webpack_public_path__ + "static/img/11.e65d8e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/sp/11.png
// module id = lSO4
// module chunks = 0